import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import kebabCase from 'lodash/kebabCase'
import * as UI from '../../components/CommonStyles'
import Service from './components/Service'
import { SPEAKABLE_SUMMARY } from 'constant'


const BOTServiceCategoryDetails = ({
  serviceCategoriesDetails: {
    categoryName,
    categorySubtitle,
    services = [],
    serviceSchemas
  } = {}
}) =>
  Boolean(services.length) &&
  <Wrapper>
    <Helmet>
      {serviceSchemas.map(schema => (
        <script type="application/ld+json">
          {schema}
        </script>
      ))}
    </Helmet>

    <UI.Title data-at-heading={ kebabCase(categoryName) }>{ categoryName }</UI.Title>
    <UI.SubHead data-at-heading-subhead={ kebabCase(categoryName) } className={ SPEAKABLE_SUMMARY }>
      { categorySubtitle }
    </UI.SubHead>
    <ServicesWrapper>
      { services.map((service, index) => (
        <Service
          key={ service.displayName }
          { ...service }
          expanded />
      )) }
    </ServicesWrapper>
  </Wrapper>

BOTServiceCategoryDetails.propTypes = {
  serviceCategoriesDetails: PropTypes.shape({
    services: PropTypes.arrayOf(),
    categorySubtitle: PropTypes.string,
    categoryName: PropTypes.string,
    serviceSchemas: PropTypes.arrayOf(PropTypes.string)
  }),
  subtitle: PropTypes.string
}

export default BOTServiceCategoryDetails

const Wrapper = styled.div`
  ${Mixin.responsive('padding', '18px 0 26px', '22px 16px 34px')}
`

const ServicesWrapper = styled(UI.ServiceWrapper)`
  ${Mixin.responsive('padding', '30px 0 0', '20px 0 0')}
`
